export default __webpack_public_path__ + "static/media/nursing-ce.1727065b.svg";